module.exports = __webpack_public_path__ + "img/basho.d0de8546.jpg";